/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Synced_CountInputs */

const en_settings_synced_count = /** @type {(inputs: Settings_Synced_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synced ${i?.count} contacts.`)
};

const he_settings_synced_count = /** @type {(inputs: Settings_Synced_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`סונכרנו ${i?.count} אנשי קשר.`)
};

/**
* | output |
* | --- |
* | "Synced {count} contacts." |
*
* @param {Settings_Synced_CountInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_synced_count = /** @type {((inputs: Settings_Synced_CountInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Synced_CountInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_synced_count(inputs)
	return he_settings_synced_count(inputs)
});